// Shared by the PRODA connection manager and the reference-data sync status view. Not
// `formatDayTimeString` (~libs/dayjs) — that helper re-parses with the explicit format
// 'YYYY-MM-DD HH:mm', which does not reliably handle the ISO-8601-with-'Z' timestamps these APIs
// return.
const formatDate = (value: string | null | undefined): string => {
  if (!value) return '—';
  return new Date(value).toLocaleString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export default formatDate;
